<template>
       <v-layout align-center justify-center fill-height>
         <v-snackbar  v-model="errorLoading" color="error" :timeout="timeout" top="top">
            {{errorMsg}}
        </v-snackbar>
          <v-flex xs12 sm8 md4>
            <v-slide-x-transition duration="500" hide-on-leave>
              <v-card tile flat class="login_card" v-if="loginFrame == 'Login'">
                 <div class="loading" v-if="loading">
                    <v-layout align-center justify-center row fill-height>
                      <v-progress-circular :size="25" :width="3" color="grey" indeterminate >
                          </v-progress-circular>
                    </v-layout>
                  </div>
                <v-progress-linear v-if="isLoading" class="linear_loading" height="3" :indeterminate="true"></v-progress-linear>
                <v-layout align-center justify-center row>
                  <v-avatar style="margin-left: -15px;" size="80" tile="tile"><img :src="JJ" /></v-avatar>
                </v-layout>
                <v-card-text>
                  <v-form>
                    <v-text-field
                        v-validate="'required'"
                        required
                        :error-messages="errors.collect('UserName')"
                        data-vv-name="UserName"
                        class="form_input"
                        v-model="userModel.username"
                        prepend-icon="person"
                        name="login"
                        label="Username (Email)"
                        hint="Please enter your email"
                        type="text"
                        outline
                    ></v-text-field>
                    <v-text-field
                        v-validate="'required'"
                        required
                        :error-messages="errors.collect('password')"
                        data-vv-name="password"
                        class="form_input"
                        v-model="userModel.password"
                        prepend-icon="lock"
                        name="password"
                        label="Password"
                        id="password"
                        type="password"
                        outline
                      ></v-text-field>
                      <v-checkbox class="form_remember"
                          v-model="userModel.remember"
                          label="Remember me"
                          type="checkbox"
                          required
                        ></v-checkbox>
                  </v-form>
                </v-card-text>
                <v-card-actions>
                  <div class="hidden-sm-and-up">
                    <v-btn class="login_btn" style="padding-left:0;" flat small color="primary" to="/register">Sign Up</v-btn>
                    <v-btn class="login_btn" flat small color="primary" @click="changeFrame('Forgot')">Forgot password?</v-btn>
                  </div>
                  <v-btn class="login_btn hidden-xs-only" flat small color="primary" @click="changeFrame('Forgot')">Forgot password?</v-btn>
                  <v-btn class="login_btn hidden-xs-only" flat small color="primary" to="/register">Sign Up</v-btn>
                  <v-spacer></v-spacer>
                  <v-btn outline color="indigo" small class="login_btn" light @click.prevent="login()">Login</v-btn>
                </v-card-actions>
              </v-card>
            </v-slide-x-transition>
            <v-slide-x-transition duration="500" hide-on-leave>
              <v-card tile flat class="login_card" v-if="loginFrame == 'Forgot'">
                <v-progress-linear v-if="isLoading" class="linear_loading" height="3" :indeterminate="true"></v-progress-linear>
                <v-layout align-center justify-center row>
                  <v-avatar style="margin-left: -15px;" size="80" tile="tile"><img :src="JJ" /></v-avatar>
                </v-layout>
                <v-card-text>
                  <v-form>
                    <v-text-field
                       class="form_input"
                        prepend-icon="person"
                        name="login"
                        label="Username"
                        type="text"
                        outline
                    ></v-text-field>
                  </v-form>
                </v-card-text>
                <v-card-actions>
                  <v-btn class="login_btn" flat small color="primary" @click="changeFrame('Login')">Login</v-btn>
                  <v-spacer></v-spacer>
                  <v-btn outline color="indigo" small light class="login_btn">Verfiy Email</v-btn>
                </v-card-actions>
              </v-card>
            </v-slide-x-transition>
          </v-flex>
        </v-layout>
</template>
<script>
import JJ from '@/assets/gitpage_icon.png';
import webmms from "webmms-client";
import { set as setCookie, get as getCookie, remove as removeCookie } from "es-cookie";
import { setTimeout } from 'timers';
import conf from '@/config/config';

export default {
    $_veeValidate: {
        validator: 'new'
    },
 data() {
    return {
      drawer: null,
      JJ,
      loading: false,
      isLoading: false,
      error: true,
      errorLoading: false,
      errorMsg: '',
      timeout: 3000,
      mmsReady: false,
      loginFrame: 'Login',
      mms: null,
      userModel: {
        username: '',
        password: '',
        remember: false
      },
      yp:{
        ddn: 'UC',
        topic: '',
        func: 'ucLogin'
      },
      eiInfo: {
        eiName: '',
        eiTag: '',
        ddn : ''
      },
      webmmsOptions : {
          EiToken: '',
          SToken: '',
          UToken: ''
      },
    }
  },
  async created() {
      this.startMMS();
  },
  async beforeMount() {
      await this.subscribeMMS();
  },
  beforeDestroy() {
    this.removeEvent();
  },
  methods : {
    changeFrame(frame){
        this.isLoading = true;
        setTimeout(()=>{
            this.loginFrame = frame;
            this.isLoading = false;
        }, 1000);
    },
     startMMS(){
          this.mms =  webmms({
            wsurl: conf.wsurl,
            EiToken: getCookie("login-EiToken") || "",
            SToken: getCookie("login-SToken") || ""
          });
      },
      async login(){
          let valid = await this.$validator.validate();
          if(!valid)
            return;

          const { ddn, topic, func } = this.yp;
          this.isLoading = true;
          this.loading = true;
            let res;
            try {
               res = await this.mms.callMMS({
                  DDN : ddn,
                  topic : topic,
                  func: func,
                  payload: [this.userModel.username, this.userModel.password, this.userModel.remember]
              });
            } catch (error) {

            }
            this.loading = false;
            this.isLoading = false;
            if(res){
                let result;
                if(typeof res == 'object')
                    result = res;
                else
                    result = res[0];
               if(Array.isArray(result))
                    result = result[0];
               console.log(result);

               if(result.ErrMsg != 'OK'){
                    this.errorLoading = true;
                    this.errorMsg = result.ErrMsg;
                }else if(result.ErrMsg == 'OK'){
                  result.result.expiresIn = 60;
                  this.$store.dispatch('login', result.result);
                  this.$router.push("browser");
                }
            }
      },
      async subscribeMMS() {
        this.removeEvent = this.mms.on("registered", async reply => {
            //console.log('reply=%s', JSON.stringify(reply))
             if(reply.ErrMsg == "OK"){
                this.eiInfo.ddn = reply.result.DDN;
                this.webmmsOptions.EiToken = reply.result.EiToken;
                this.webmmsOptions.SToken = reply.result.SToken;
                this.webmmsOptions.UToken = reply.result.UToken;
                if(this.eiInfo.eiName == ''){
                  this.eiInfo.eiName = reply.result.EiName ? reply.result.EiName : 'urt' + this.makeId(5);
                }
                 if(this.eiInfo.eiTag == ''){
                  this.eiInfo.eiTag = reply.result.EiTag ? reply.result.EiTag : '';
                }
             }

             let expiredTime = 60 * 60 * 24 * 30 * 12;

             setCookie("login-EiToken", this.webmmsOptions.EiToken);
             setCookie("login-SToken", this.webmmsOptions.SToken);


            console.log('regtoCenter: %s', reply.ErrMsg);
            this.mmsReady = true;
            this.error = false;
            //  let deviceInfo = {"DDN":this.eiInfo.ddn,"EiOwner":"","EiName":this.eiInfo.eiName,"EiType":".page","EiTag":this.eiInfo.eiTag,"EiLoc":""};
            //  let result = await this.mms.setDeviceInfo(deviceInfo);
            //  console.log('SetDevice reply=%s', JSON.stringify(result));
            //  this.setLog({'SetDevice reply':result}, 'State');
        });

        this.mms.on('message', (method, from, data, body) => {
             this.mmsReady = true;
             this.error = false;
             console.log('rcve: from=%s, data=%s', from, JSON.stringify(data));
            if(typeof data == 'object' && !data.from)
              data.from = from;
            //body.sender = data;
            if(data)
            {

              //this.eventList.push(data.data);


            }
        });

        this.mms.on('state', msg => {
            console.log('WS error: %s', msg);
            this.mmsReady = false;
            this.error = true;
        });

        this.mms.on('disconnect', msg => {
            this.mmsReady = false;
            this.error = true;
        });

        this.mms.on('error', err => {
             this.mmsReady = false;
            this.error = true;
        });

        this.mms.on('connect_error', err => {
            this.mmsReady = false;
            this.error = true;
        });

        this.mms.on('connect_timeout', err => {
            this.mmsReady = false;
            this.error = true;
        });
      }
  }

}
</script>
<style scoped>
.login_card{
  margin: 15px;
  border: 1px solid #e3e0e0;
}
.linear_loading{
  margin: 0;
}
.login_btn{
  text-transform: unset;
}
.form_input{
  margin-left: 10px;
  margin-right: 5px;
}
.form_remember{
      margin-left: 15px;
    margin-top: 0;
    margin-bottom: 0;
}
  .loading{
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left:0;
  z-index: 50;
  background-color: rgba(255, 255, 255, 0.4196078431372549);
}
</style>
<style>
.form_input  .v-input__slot{
    border: 2px solid rgba(199, 199, 199, 0.54) !important;
}
</style>
